var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Modal from "../components/Modal";
import React, { useCallback, useState } from 'react';
import useBrowserBackButton from './useBrowserBackButton';
export default (function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.withCloseIcon, withCloseIcon = _c === void 0 ? true : _c;
    var _d = useState(false), visible = _d[0], setVisible = _d[1];
    var _e = useBrowserBackButton(), addBackButtonListener = _e.addBackButtonListener, removeBackButtonListener = _e.removeBackButtonListener;
    var showModal = useCallback(function () {
        setVisible(true);
        addBackButtonListener(function () { return setVisible(false); });
    }, [setVisible, addBackButtonListener]);
    var hideModal = useCallback(function () {
        setVisible(false);
        removeBackButtonListener();
    }, [setVisible, removeBackButtonListener]);
    var Component = useCallback(function (_a) {
        var onClose = _a.onClose, props = __rest(_a, ["onClose"]);
        var handleClose = useCallback(function () {
            hideModal();
            onClose && onClose();
        }, [hideModal, onClose]);
        return visible ? (React.createElement(Modal, __assign({ onClose: withCloseIcon ? handleClose : undefined }, props))) : null;
    }, [showModal, hideModal, visible]);
    return { showModal: showModal, hideModal: hideModal, Modal: Component };
});
//# sourceMappingURL=useModal.js.map